import React from 'react';
import { AdmissionCalculator as AdmissionCalculatorComponent } from '../components/calculator/AdmissionCalculator';

export const AdmissionCalculatorPage: React.FC = () => {
  return <AdmissionCalculatorComponent />;
};